import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import { FONTS } from '../../../constants'

export const SaleProductItem = React.memo(({
  item,
  activeItem,
  lobList,
  handleClickRow,
}) => {
  const lob = lobList.find(l => l.value === item.lob_id)

  return (
    <Root
      active={ item._id === activeItem }
      onClick={ () => handleClickRow(item) }
    >
      <CodeCol>{ item.product_code }</CodeCol>
      <NameCol>{ item.name }</NameCol>
      <LOBCol>{ lob ? lob.label : '-' }</LOBCol>
      <StateDateCol>{ moment(item.start_date).format('DD/MM/YYYY') }</StateDateCol>
      <EndDateCol>{ moment(item.end_date).format('DD/MM/YYYY') }</EndDateCol>
    </Root>
  )
})

const Root = styled.div`
    height: 35px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    background: ${p => (p.active ? 'rgba(0, 0, 0, 0.075)' : '#FFFFFF')};
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #1A1A17;
    border-top: 1px solid #EAEAEA;
    cursor: pointer;

    :nth-child(1) {
        border: none;
    }

    :hover {
      background-color: rgba(0, 0, 0, 0.075);
    }
`

const CodeCol = styled.div`
    flex: 2;

    svg {
      margin-left: 8px;
      font-size: 16px;
    }
`

const NameCol = styled(CodeCol)`
    flex: 3;
`

const LOBCol = styled(CodeCol)`
    flex: 3;
`

const StateDateCol = styled(CodeCol)`
    flex: 2;
`

const EndDateCol = styled(CodeCol)`
    flex: 2;
`



// WEBPACK FOOTER //
// ./src/components/sale-product/data-table/sale-product-item.js